















































































































import { Component, Vue } from 'vue-property-decorator'
import EarthLayout from '@/components/layout/EarthLayout.vue'
import TranslationModule from '@/utils/TranslationModule'
import { Member } from '@/types/Member.type'
import { namespace } from 'vuex-class'
import API from '@/services/API'
import AuthEmptyLayout from '@/layouts/AuthEmptyLayout.vue'
import AuthCard from '@/components/layout/auth/AuthCard.vue'
import { safeFrenchFoundersRedirect } from '@/utils/safeRedirect.ts'
import SharedStorage from '@/utils/SharedStorage'
import AuthLayoutMondrian from '@/layouts/AuthLayoutMondrian.vue'

const User = namespace('user')
const MAX_LOOP_COUNT = 3

@Component({
    components: { AuthCard, AuthEmptyLayout, EarthLayout, AuthLayoutMondrian },
})
export default class AuthLayout extends Vue {
    @User.State me!: Member
    TranslationModule: typeof TranslationModule = TranslationModule
    shake = false
    loaded = false
    displayLang = 'fr'

    get isLesTalents() {
        return this.$route.query && this.$route.query.context === 'lestalents'
    }

    get isMondrian() {
        return true
    }

    get isBpiCircle() {
        return this.$route.query && this.$route.query.from === 'cfo-bpi'
    }

    created() {
        this.preventInfiniteLoop()

        if (this.$route.query.lang && !Array.isArray(this.$route.query.lang)) {
            this.displayLang = this.$route.query.lang
        }

        this.$root.$on('authError', () => {
            this.shakeCard()
        })

        if (this.me) {
            this.alreadyLogin()
        } else {
            this.loaded = true
        }
    }

    /**
     * Pour éviter la boucle infinie, on gère côté front un compteur pour savoir dans les X dernières minutes combien de fois nous
     * sommes arrivé sur la page "/login". Si on dépasse le <MAX_LOOP_COUNT>, on force logout l'utilisateur
     */
    preventInfiniteLoop() {
        const INFINITE_LOOP_COUNTER_KEY = 'INFINITE_LOOP_COUNTER'
        const loopCounter = Number(SharedStorage.get(INFINITE_LOOP_COUNTER_KEY)) + 1

        if (loopCounter < MAX_LOOP_COUNT) {
            const expiration = new Date()
            expiration.setMinutes(expiration.getMinutes() + 2)
            SharedStorage.set(INFINITE_LOOP_COUNTER_KEY, String(loopCounter), expiration)
        } else {
            SharedStorage.delete(INFINITE_LOOP_COUNTER_KEY)
            this.$store.dispatch('user/logout', this.$route.query.targetUrl)
        }
    }

    shakeCard() {
        this.shake = true

        setTimeout(() => {
            this.shake = false
        }, 2000)
    }

    alreadyLogin() {
        // si on est déjà connecté et qu'on veut aller dans le context LesTalents => on redirige vers le magic link
        if (this.$route.path.match(/register/) && this.isLesTalents) {
            window.location.href = '/login?context=lestalents'
            return
        }

        // throw force login to be sure to be logged in everywhere
        API.forceLogin()
            .then(() => {
                safeFrenchFoundersRedirect(
                    (this.$route.query.redirectUrl as string) ||
                        (this.$route.query.redirect as string) ||
                        (window.loginTargetUrl as string) ||
                        '/'
                )
            })
            .finally(() => {
                this.loaded = true
            })
    }
}
